module.exports = __webpack_public_path__ + "img/txt.817e450.svg";